import type { ReactNode } from 'react';
import type { ViewProps } from 'react-native';
import { Badge } from './Badge';

type DarkPrecisionStatus = 'success' | 'warning' | 'danger';

interface BadgePresetProps extends Omit<ViewProps, 'children'> {
  children: ReactNode;
  size?: 'sm' | 'md';
}

interface StatusBadgeProps extends BadgePresetProps {
  status: DarkPrecisionStatus;
}

const statusColorMap: Record<DarkPrecisionStatus, 'green' | 'amber' | 'red'> = {
  success: 'green',
  warning: 'amber',
  danger: 'red',
};

export function OverviewBadge({ children, size = 'md', ...rest }: Readonly<BadgePresetProps>) {
  return (
    <Badge color="cyan" variant="filled" size={size} {...rest}>
      {children}
    </Badge>
  );
}

export function MutedBadge({ children, size = 'md', ...rest }: Readonly<BadgePresetProps>) {
  return (
    <Badge color="neutral" variant="subtle" size={size} {...rest}>
      {children}
    </Badge>
  );
}

export function StatusBadge({
  status,
  children,
  size = 'md',
  ...rest
}: Readonly<StatusBadgeProps>) {
  return (
    <Badge color={statusColorMap[status]} variant="subtle" size={size} {...rest}>
      {children}
    </Badge>
  );
}

export type { DarkPrecisionStatus };
